import { Reducer } from 'redux';
import { Action, ActionType } from '../../../actions';
import { EditorData } from '../../../state/BookingCreateManagerV2/Remarks/EditorData';

const updateBookingCreateManagerV2RemarksEditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_FETCHED:
      return { ...state, bookingCreateManagerRemarksEditorData: action.data };
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_UPDATED:
      return { ...state, bookingCreateManagerRemarksEditorData: { ...state.bookingCreateManagerRemarksEditorData, ...action.data } };
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: { ...action.data } };
    default:
      return state;
  }
};

export default updateBookingCreateManagerV2RemarksEditorData;
